import { render, staticRenderFns } from "./DetailCheckOrder.vue?vue&type=template&id=3c6bc734&"
import script from "./DetailCheckOrder.vue?vue&type=script&lang=js&"
export * from "./DetailCheckOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports